module.exports = __webpack_public_path__ + "static/media/peeled_tomatoes_juice.d2101238.png";